import { API } from "@nosto/client-lib"
import { nostojs } from "./api"
import settings from "@/core/settings"

function getCurrentVariant() {
  const parameters = new URLSearchParams(window.location.search)
  return parameters.get("variant")
}

function getCurrentProductId(api: API) {
  const { products } = api.pageTagging()
  if (!products.length) {
    return null
  }
  return products[0].product_id
}

function initSkuListener(window: Window, api: API) {
  const testRun = window.nostoab?.settings?.shopifySkuSelectionListener

  if (!(settings.shopifySkuSelectionListener || testRun)) {
    return
  }

  const delayMillis = testRun ? 10 : 500
  let oldVariant = getCurrentVariant()
  let oldProductId = getCurrentProductId(api)
  // listen for changes
  setInterval(function () {
    const currentProductId = getCurrentProductId(api)
    const variant = getCurrentVariant()
    if (oldProductId === currentProductId && oldVariant !== variant) {
      api.loadRecommendations()
    }
    oldVariant = variant
    oldProductId = currentProductId
  }, delayMillis)
}

export default function init(window: Window) {
  nostojs(api => {
    api.internal.modifySettings({ skuParam: "variant" })
    initSkuListener(window, api)
  })
}
